import aiEmployees from './ai-employees';

let messages = Object.assign({}, aiEmployees);

export default messages;
